import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import type { VersionFieldType } from '@atlassian/jira-issue-table-grouping-issue-create-utils/src/optimistic-responses/types.tsx';
import { VERSION_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { TextGroupHeaderContent } from '../../../../common/text-group-header-content/index.tsx';
import { TagGroupHeaderContent } from '../../../../common/tag-group-header-content/index.tsx';
import type { VersionGroupHeader$key } from './__generated__/VersionGroupHeader.graphql';
import messages from './messages.tsx';

export type Props = {
	versionGroupHeader: VersionGroupHeader$key | null;
	fieldType: VersionFieldType;
};

export const VersionGroupHeader = ({ versionGroupHeader, fieldType }: Props) => {
	const data = useFragment<VersionGroupHeader$key>(
		graphql`
			fragment VersionGroupHeader on JiraJqlVersionFieldValue {
				displayName
				version {
					name
				}
			}
		`,
		versionGroupHeader,
	);

	const { formatMessage } = useIntl();

	return fieldType === VERSION_CF_TYPE ? (
		<TextGroupHeaderContent
			text={data?.displayName || data?.version?.name}
			noValueText={formatMessage(messages.noVersion)}
		/>
	) : (
		<TagGroupHeaderContent
			text={data?.displayName || data?.version?.name}
			noValueText={formatMessage(messages.noVersion)}
		/>
	);
};
